<template>
  <div ref="final">
    <div class="infinite-status-prompt" v-show="isShowSpinner">
      <slot name="spinner">...</slot>
    </div>
    <div class="infinite-status-prompt" v-show="isShowNoMore">
      <slot name="nomore">No more results</slot>
    </div>
  </div>
</template>

<script>
export const STATUS = {
  READY: 0,
  LOADING: 1,
  COMPLETE: 2,
  ERROR: 3,
};

export default {
  name: 'InfiniteLoading',
  props: {
    identifier: {
      type: Object,
      required: true,
    },
    distance: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      status: STATUS.READY,
    };
  },

  created() {
    this.stateChanger = {
      loaded: () => {
        this.$emit('$InfiniteLoading:loaded', { target: this });
      },
      complete: () => {
        this.$emit('$InfiniteLoading:complete', { target: this });
      },
      reset: () => {
        this.$emit('$InfiniteLoading:reset', { target: this });
      },
      error: () => {
        this.status = STATUS.ERROR;
      },
    };

    window.addEventListener('scroll', this.handleScroll);

    this.$on('$InfiniteLoading:complete', () => {
      this.status = STATUS.COMPLETE;
      // this.scrollParent.removeEventListener('scroll', this.scrollHandler, evt3rdArg);
    });

    this.$on('$InfiniteLoading:reset', () => {
      this.status = STATUS.READY;
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (this.status !== STATUS.COMPLETE) {
        const { final } = this.$refs;
        if (this.isInViewport(final)) {
          this.status = STATUS.LOADING;
          // force re-complation computed properties to fix the problem of get slot text delay
          this.$nextTick(() => {
            this.$forceUpdate();
          });
          this.$emit('infinite', this.stateChanger);
        }
      }
    },
    isInViewport(elem) {
      const bounding = elem.getBoundingClientRect();
      return (
        bounding.top >= 0
        && bounding.bottom - this.distance
          <= (window.innerHeight || document.documentElement.clientHeight)
      // bounding.top >= 0
      //   && bounding.left >= 0
      //   && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      //   && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
  },
  computed: {
    isShowSpinner() {
      return this.status === STATUS.LOADING;
    },
    isShowNoMore() {
      return this.status === STATUS.COMPLETE;
    },
  },
  watch: {
    identifier() {
      // caller object has changed, so reset the infinite scrolling
      this.status = STATUS.READY;
    },
  },
};
</script>
